/**
 * @module builder
 */
import type { QuoteDocument } from 'paintscout'

import _findIndex from 'lodash/findIndex'

import { getOrderOptions } from '../../util'

export function removeOrderItem(args: { quote: QuoteDocument; key: string }): QuoteDocument {
  const { quote, key } = args

  const orderOptions = getOrderOptions()
  const order: any = { ...quote.order }
  orderOptions.forEach((orderItem: any) => {
    const index = _findIndex(order[orderItem], { key })
    if (index !== -1) {
      order[orderItem][index]._deleted = true
    }
  })

  return {
    ...quote,
    order: {
      ...order
    }
  }
}
